module.exports = __webpack_public_path__ + "static/media/Training Manual ver 2_17_2012.56009600.01026806.pdf";